import React, { useState } from "react";
import "./App.css";
import HistoricalSitePage from "./components/HistoricalSitePage";
import HomePage from "./components/HomePage";
import type { SiteInfo } from "./types/site";

const defaultSite: SiteInfo = {
  id: 1,
  nombre: "Museo Nacional de Costa Rica",
  ubicacion: "Cuesta de Moras, San José, Costa Rica",
  telefono: "+506 2211 5700",
  detalle: "Icono cultural fundado en 1887 y sede del Museo Nacional.",
  latitud: 9.933,
  longitud: -84.071,
};

const sites = [defaultSite];

function App() {
  const [selectedSite, setSelectedSite] = useState<SiteInfo | null>(null);

  return (
    <div className="App">
      {selectedSite ? (
        <HistoricalSitePage
          site={selectedSite}
          onBack={() => setSelectedSite(null)}
        />
      ) : (
        <HomePage sites={sites} onSelectSite={setSelectedSite} />
      )}
    </div>
  );
}

export default App;
